import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AgentWorkflow from '../../agents/components/TogglePanel/toggelPanelItem/AgentWorkflow';
import { trainingFlowsApi } from '../../agents/services/trainingFlowsApi';
import { AgentTrainingFlow } from '../../agents/types/flowTypes';

export default function WorkflowEditorPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [workflow, setWorkflow] = useState<AgentTrainingFlow | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadWorkflow = async () => {
      if (!id) {
        setLoading(false);
        return;
      }

      try {
        const flow = await trainingFlowsApi.loadFlow(id);
        setWorkflow(flow);
      } catch (error) {
        console.error('Error loading workflow:', error);

        // Si el workflow no existe, crear uno temporal en memoria (modo maqueta)
        const mockWorkflow: AgentTrainingFlow = {
          id: id,
          user_id: '',
          agent_id: null,
          numero_telefono: null,
          nombre: 'Nuevo Workflow',
          descripcion: '',
          flow_data: {
            nodes: [],
            edges: [],
            groups: [],
            viewport: { x: 0, y: 0, zoom: 1 }
          },
          es_plantilla: false,
          is_active: false,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        };

        setWorkflow(mockWorkflow);
      } finally {
        setLoading(false);
      }
    };

    loadWorkflow();
  }, [id]);

  const handleBack = () => {
    navigate('/workflows');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-grey-600">Cargando workflow...</p>
      </div>
    );
  }

  return (
    <div className="max-h-[100%] m-[-24px] bg-background flex flex-col">
      {/* Canvas Editor con header integrado */}
      <div className="flex-1">
        <AgentWorkflow
          agent={null}
          trainingFlow={workflow}
          loadingFlow={loading}
          isStandaloneMode={true}
          workflowName={workflow?.nombre || 'Editor de Workflow'}
          onBack={handleBack}
        />
      </div>
    </div>
  );
}
